<template>
  <SymbolDetailInfo
    v-if="symbolDetailLayout === 'info'"
    :vertical="vertical"
    :portfolio-symbols="portfolioSymbols"
    :symbol="symbol"
    :is-market-map="isMarketMap"
    :show-bubble="showBubble"
  />

  <SymbolDetailSideBar
    v-else-if="symbolDetailLayout === 'sideBar'"
    :vertical="vertical"
    :portfolio-symbols="portfolioSymbols"
    :symbol="symbol"
    :is-market-map="isMarketMap"
    :show-bubble="showBubble"
  />

  <SymbolDetailMarket
    v-else-if="symbolDetailLayout === 'marketMap'"
    :vertical="vertical"
    :portfolio-symbols="portfolioSymbols"
    :symbol="symbol"
    :is-market-map="isMarketMap"
    :show-bubble="showBubble"
  />
</template>

<script setup lang="ts">
import SymbolDetailInfo from './SymbolDetailInfo.vue';
import SymbolDetailSideBar from './SymbolDetailSideBar.vue';
import SymbolDetailMarket from './SymbolDetailMarket.vue';
import { Instrument, PortfolioItem } from '@libs/api-reference';

type SymbolDetailPropsType = {
  symbolDetailLayout?: 'marketMap' | 'sideBar' | 'info';
  vertical?: boolean;
  portfolioSymbols?: PortfolioItem[] | null;
  symbol: Instrument;
  isMarketMap?: boolean;
  showBubble?: boolean;
};

withDefaults(defineProps<SymbolDetailPropsType>(), {
  symbolDetailLayout: 'info',
  vertical: false,
  portfolioSymbols: () => [],
  isMarketMap: false,
  showBubble: false,
});
</script>
